import styled from 'styled-components/native'

export const FormContainer = styled.View`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ToolTipContainer = styled.View`
  background-color: ${(props) => props.theme.colors.clientCardBg};
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small};
  padding: ${({ theme }) => `${theme.metrics.baseMargin * 1.25}px`};
  width: 100%;
  margin-bottom: ${({ theme }) => `${theme.metrics.baseMargin * 1.25}px`};
`

export const Header = styled.View`
  margin-bottom: ${({ theme }) => `${theme.metrics.baseMargin * 0.5}px`};
  gap: ${({ theme }) => `${theme.metrics.baseMargin * 0.5}px`};
`

export const StyledConsentView = styled.View<{ height: number }>`
  width: 100%;
  max-width: 800px;
  align-self: center;
  height: ${({ height }) => height}px;
  padding-bottom: ${({ theme }) => `${theme.metrics.baseMargin * 0.5}px`};
`
